import { Component, Inject } from '@angular/core';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { Condo } from '@api/model/condo';
import { CondoService } from '@api/service/condo.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { timeout } from 'rxjs/operators';

@Component({
  selector: 'app-modal-notify-condo',
  templateUrl: './modal-notify-condo.html',
  styleUrls: ['./modal-notify-condo.scss']
})
export class ModalNotifyCondo {
  condo!: Condo;

  form: UntypedFormGroup;

  constructor(
    private notification: NzNotificationService,
    private modalService: NzModalService,
    private condoService: CondoService,
    private formBuilder: UntypedFormBuilder,
    @Inject(NZ_MODAL_DATA) data: { condo: Condo }
  ) {
    this.condo = data.condo;

    this.form = this.formBuilder.group({
      title: ['Produtos e serviços', Validators.required],
      message: ['Mensagem sobre produtos e serviços', Validators.required],
      type: ['OPEN-URL', Validators.required],
      url: ['https://lar-e-assistencia.com.br', Validators.required]
    });
  }

  submit(form: UntypedFormGroup) {
    if (form.valid) {
      const notificationData = form.value;
      this.condoService
        .notifyCondo(this.condo._id, notificationData)
        .pipe(timeout(50000))
        .subscribe({
          next: res => {
            this.notification.create('success', 'Notificação enviada', 'A notificação foi enviada');
            this.closeModal();
          },
          error: err => {
            console.log(err);
            const error = err.error?.error || err.toString();
            this.notification.create('error', 'Notificação não enviada', error);
          }
        });
    }
  }

  closeModal() {
    this.modalService.closeAll();
  }
}
